import basketStore from '@/store/basket'

import useIncentive from '@/hooks/useIncentive'

import { getNextRoute } from '@/helpers/Route'
import { ROUTE_NAME } from '@/config/constants.js'

// HOOKS
const { incentives } = useIncentive()

export default [
  {
    beforeEnter: (to, _from) => {
      const selectedQuiz = incentives.value.find(i => i.id === to.params?.quizId)
      if (!selectedQuiz) {
        return {
          name: getNextRoute(basketStore.basket),
        }
      }
    },
    path: '/quiz/:quizId',
    meta: {
      headerDisabled: true,
      navigation: false,
    },
    children: [
      {
        path: '',
        name: ROUTE_NAME.QUIZ,
        component: () => import('@/modules/Configurator/screens/Quiz/ScreenGame.vue'),
        props: true,
      },
      {
        beforeEnter: (_to, from) => {
          if (from.name !== ROUTE_NAME.QUIZ) {
            return {
              name: getNextRoute(basketStore.basket),
            }
          }
        },
        path: 'form',
        name: ROUTE_NAME.QUIZ_FORM,
        component: () => import('@/modules/Configurator/screens/Quiz/ScreenForm.vue'),
        props: true,
      },
      {
        beforeEnter: (_to, from) => {
          if (from.name !== ROUTE_NAME.QUIZ_FORM) {
            return {
              name: getNextRoute(basketStore.basket),
            }
          }
        },
        path: 'success',
        name: ROUTE_NAME.QUIZ_SUCCESS,
        component: () => import('@/modules/Configurator/screens/Quiz/ScreenSuccess.vue'),
      },
    ],
  },
]
